// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   // const [selectedType, setSelectedType] = useState('');
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     // Export client details
//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       // Create a new row for the table data array
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };
//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//     if (clientRowCreated && selectedClient !== "") {
//       // Perform actions that depend on updated state
//       // For example, you can trigger the type change for the new row
//       // handleTypeChange(0, tableData[0].type);
//     }
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   //category type get
//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // to get client details ---------------
//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   // get invoice no. ----------------------------
//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo); // Use setinvoicejustno consistently

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//         .toString()
//         .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`; // Use updatedInvoiceJustNo instead of getinvoicejustno

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // get current date---------------------------------------
//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.type !== "") {
//         if (item.projectName === "") {
//           emptyFields.push(`Project Name at row ${index + 1}`);
//         }
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       alert(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   // submit data
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   // submit data
//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);
//           const filteredTableData = updatedTableData.filter(
//             (item) => item.type.trim() !== ""
//           );

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2),
//             notes: getData.notes,
//             totalTax: tax.toFixed(2),
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           console.log("submit data", requestData);

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           console.log(response.data);

//           if (response.data.status === "success") {
//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               type: item.type,
//               quantity: item.quantity,
//               price: item.price,
//               tax: item.tax,
//               amount:
//                 item.amount !== ""
//                   ? item.amount
//                   : (
//                       parseFloat(item.price) * exchangeRate +
//                       parseFloat((item.price * exchangeRate * item.tax) / 100)
//                     ).toFixed(2),
//               rate:
//                 item.rate !== ""
//                   ? item.rate
//                   : (
//                       parseFloat(item.price) +
//                       parseFloat((item.price * item.tax) / 100)
//                     ).toFixed(2),
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                   100
//               ).toFixed(2),
//             }));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   // const [getlastinvoiceno, setlastinvoiceno] = useState('')
//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         try {
//           const response = await axios.get(apiUrl + "/invoicenoget");
//           console.log("response id ", response.data);
//           // setlastinvoiceno(response.data);
//           navigate(`/invoice/invoiceprint/${response.data}`, {});
//         } catch (error) {
//           console.log(error);
//         }

//         // navigate('/bill', {
//         //     state: {
//         //         invoiceData: {
//         //             invoiceId: getinvoiceno,
//         //             currentDate,
//         //             dueDate: getData.dueDate,
//         //             getclientName,
//         //             getclientaddress,
//         //             getclientcountry,
//         //             getclientmobile,
//         //             tableData,
//         //             subtotal,
//         //             tax: tax.toFixed(2),
//         //             netTotal,
//         //             notes: getData.notes,

//         //         }
//         //     }
//         // });
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   // Net Total Logic
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       // FOREIGN → USD converted amount
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       // INDIA → INR direct amount
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4"></div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "10%" }}>Type</th>
//                   {/* <th style={{ width: "6%" }}>Qty</th> */}
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>
//                   <th style={{ width: "4%" }}>col-7</th>
//                   <th style={{ width: "4%" }}>col-8</th>
//                   <th style={{ width: "4%" }}>col-9</th>
//                   <th style={{ width: "4%" }}>col-10</th>
//                   <th style={{ width: "4%" }}>col-11</th>
//                   <th style={{ width: "4%" }}>col-12</th>
//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   {/* {getclientcountry === "91" ? null : ( */}
//                   <th
//                     // className="d-flex border-0 gap-1 pe-4"
//                     style={{ width: "7%" }}
//                   >
//                     ₹ Amount
//                   </th>
//                   {/* )} */}
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <td>
//                         <input
//                           style={{ width: "100%" }}
//                           className="form-control"
//                           type="text"
//                           value={item.projectName}
//                           onChange={(e) =>
//                             handleUserInputChange(
//                               index,
//                               "projectName",
//                               e.target.value
//                             )
//                           }
//                         />
//                       </td>
//                     </td>
//                     <td>
//                       <div className="position-relative">
//                         <select
//                           className="form-control dropdown-toggle custom-select"
//                           value={tableData[index].type}
//                           onChange={(e) =>
//                             handleTypeChange(index, e.target.value)
//                           }
//                         >
//                           <option value="">Select a type</option>
//                           {getCategoryType
//                             .filter(
//                               (item) =>
//                                 (getclientcountry === "91" &&
//                                   item.INRprice !== "") ||
//                                 (getclientcountry !== "91" && item.price !== "")
//                             )
//                             .map((item) => (
//                               <option key={item.id} value={item.type}>
//                                 {item.type}
//                               </option>
//                             ))}
//                         </select>
//                         <div className="dropdown-arrow"></div>
//                       </div>
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col7}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col7", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col8}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col8", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col9}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col9", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col10}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col10", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col11}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col11", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.col12}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "col12", e.target.value)
//                         }
//                       />
//                     </td>
//                     {/* <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.quantity}
//                         onChange={(e) => {
//                           const size = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 30);
//                           handleUserInputChange(index, "quantity", size);
//                         }}
//                       />
//                     </td> */}
//                     {/* <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={
//                           getclientcountry === "91"
//                             ? `₹${item.price}`
//                             : `$${item.price}`
//                         }
//                         onChange={(e) => {
//                           const size = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 30);
//                           handleUserInputChange(
//                             index,
//                             "price",
//                             size.replace("$", "")
//                           );
//                         }}
//                       />
//                     </td> */}
//                     {/* <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={
//                           getclientcountry === "91"
//                             ? `₹${tableData[index].price}`
//                             : `$${tableData[index].price}`
//                         }
//                         onChange={(e) => {
//                           const size = e.target.value
//                             .replace(/\D/g, "")
//                             .slice(0, 30);
//                           handleUserInputChange(
//                             index,
//                             "price",
//                             size.replace("$", "")
//                           );
//                         }}
//                       />
//                     </td> */}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     {/* <td>
//                       <input
//                         className="form-control"
//                         type="number"
//                         value={item.tax}
//                         placeholder="Enter Tax"
//                         onChange={(e) =>
//                           handleUserInputChange(index, "tax", e.target.value)
//                         }
//                       />
//                     </td> */}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");

//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     {/* <td>
//                       <p>
//                         ₹{" "}
//                         {(
//                           parseFloat(item.price * exchangeRate) +
//                           parseFloat(
//                             (item.price * exchangeRate * item.tax) / 100
//                           )
//                         ).toFixed(2)}
//                       </p>
//                     </td> */}

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         // Default auto value if item.amount is empty
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                                 parseFloat(item.price * exchangeRate) +
//                                 parseFloat(
//                                   (item.price * exchangeRate * item.tax) / 100
//                                 )
//                               ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     {/* <td>
//                       <input
//                         type="tel"
//                         className="form-control"
//                         placeholder="Amount"
//                         value={item.amount || 0}
//                         onChange={(e) => {
//                           // Allow only numbers
//                           const onlyNumbers = e.target.value.replace(
//                             /[^0-9]/g,
//                             ""
//                           );
//                           handleUserInputChange(index, "amount", onlyNumbers);
//                         }}
//                       />
//                     </td> */}

//                     {/* <td>
//                       <p>
//                         {getclientcountry === "91"
//                           ? `₹ ${(
//                               parseFloat(item.quantity) *
//                                 parseFloat(item.price) +
//                               parseFloat(
//                                 (item.tax * item.quantity * item.price) / 100
//                               )
//                             ).toFixed(2)}`
//                           : `$ ${(
//                               parseFloat(item.quantity) *
//                                 parseFloat(item.price) +
//                               parseFloat(
//                                 (item.tax * item.quantity * item.price) / 100
//                               )
//                             ).toFixed(2)}`}
//                       </p>
//                     </td> */}

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                                 parseFloat(item.price * item.tax) / 100 +
//                                 parseFloat(item.price)
//                               ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     {/* <td>
//                       <input
//                         type="tel"
//                         className="form-control"
//                         placeholder="Rate"
//                         value={item.rate || 0}
//                         onChange={(e) => {
//                           // Allow only numbers
//                           const onlyNumbers = e.target.value.replace(
//                             /[^0-9]/g,
//                             ""
//                           );
//                           handleUserInputChange(index, "rate", onlyNumbers);
//                         }}
//                       />
//                     </td> */}

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `$${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `$${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>
//                 {/* <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${netTotal.toFixed(2)}`
//                           : `$${netTotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Net Total"
//                     />
//                   </div>
//                 </div> */}

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `$${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   // State for dynamic columns
//   const [visibleColumns, setVisibleColumns] = useState(0); // 0 means no extra columns visible
//   const [columnNames, setColumnNames] = useState({
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });
//   const [isEditingColumnName, setIsEditingColumnName] = useState(null);
//   const [tempColumnName, setTempColumnName] = useState("");

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   // Function to add a new column
//   const handleAddColumn = () => {
//     if (visibleColumns < 6) {
//       setVisibleColumns(visibleColumns + 1);
//     }
//   };

//   // Function to start editing column name
//   const handleEditColumnName = (columnKey) => {
//     setIsEditingColumnName(columnKey);
//     setTempColumnName(columnNames[columnKey]);
//   };

//   // Function to save column name
//   const handleSaveColumnName = (columnKey) => {
//     if (tempColumnName.trim() !== "") {
//       setColumnNames({
//         ...columnNames,
//         [columnKey]: tempColumnName
//       });
//     }
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   // Function to cancel editing
//   const handleCancelEdit = () => {
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     // Export client details
//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   //category type get
//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // to get client details ---------------
//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   // get invoice no. ----------------------------
//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo);

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//         .toString()
//         .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`;

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // get current date---------------------------------------
//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.type !== "") {
//         if (item.projectName === "") {
//           emptyFields.push(`Project Name at row ${index + 1}`);
//         }
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       alert(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   // submit data
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   // submit data
//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);
//           const filteredTableData = updatedTableData.filter(
//             (item) => item.type.trim() !== ""
//           );

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2),
//             notes: getData.notes,
//             totalTax: tax.toFixed(2),
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           console.log("submit data", requestData);

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           console.log(response.data);

//           if (response.data.status === "success") {
//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               col10: item.col10,
//               col11: item.col11,
//               col12: item.col12,
//               type: item.type,
//               quantity: item.quantity,
//               price: item.price,
//               tax: item.tax,
//               amount:
//                 item.amount !== ""
//                   ? item.amount
//                   : (
//                       parseFloat(item.price) * exchangeRate +
//                       parseFloat((item.price * exchangeRate * item.tax) / 100)
//                     ).toFixed(2),
//               rate:
//                 item.rate !== ""
//                   ? item.rate
//                   : (
//                       parseFloat(item.price) +
//                       parseFloat((item.price * item.tax) / 100)
//                     ).toFixed(2),
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                   100
//               ).toFixed(2),
//             }));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         try {
//           const response = await axios.get(apiUrl + "/invoicenoget");
//           console.log("response id ", response.data);
//           navigate(`/invoice/invoiceprint/${response.data}`, {});
//         } catch (error) {
//           console.log(error);
//         }
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   // Net Total Logic
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   // Map column keys to their display order
//   const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               {/* Add Column Button */}
//               {visibleColumns < 6 && (
//                 <div className="mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "10%" }}>Type</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>

//                   {/* Dynamic columns */}
//                   {columnOrder.slice(0, visibleColumns).map((colKey, idx) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       {isEditingColumnName === colKey ? (
//                         <div className="d-flex align-items-center gap-1">
//                           <input
//                             type="text"
//                             className="form-control form-control-sm"
//                             value={tempColumnName}
//                             onChange={(e) => setTempColumnName(e.target.value)}
//                             onKeyPress={(e) => {
//                               if (e.key === 'Enter') {
//                                 handleSaveColumnName(colKey);
//                               }
//                             }}
//                             autoFocus
//                           />
//                           <button
//                             className="btn btn-success btn-sm p-1"
//                             onClick={() => handleSaveColumnName(colKey)}
//                           >
//                             <i className="fa-solid fa-check"></i>
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm p-1"
//                             onClick={handleCancelEdit}
//                           >
//                             <i className="fa-solid fa-times"></i>
//                           </button>
//                         </div>
//                       ) : (
//                         <div 
//                           className="d-flex align-items-center justify-content-between"
//                           style={{ cursor: 'pointer' }}
//                           onClick={() => handleEditColumnName(colKey)}
//                         >
//                           <span>{columnNames[colKey]}</span>
//                           <i className="fa-solid fa-edit ms-1" style={{ fontSize: '12px' }}></i>
//                         </div>
//                       )}
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <div className="position-relative">
//                         <select
//                           className="form-control dropdown-toggle custom-select"
//                           value={tableData[index].type}
//                           onChange={(e) =>
//                             handleTypeChange(index, e.target.value)
//                           }
//                         >
//                           <option value="">Select a type</option>
//                           {getCategoryType
//                             .filter(
//                               (item) =>
//                                 (getclientcountry === "91" &&
//                                   item.INRprice !== "") ||
//                                 (getclientcountry !== "91" && item.price !== "")
//                             )
//                             .map((item) => (
//                               <option key={item.id} value={item.type}>
//                                 {item.type}
//                               </option>
//                             ))}
//                         </select>
//                         <div className="dropdown-arrow"></div>
//                       </div>
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs */}
//                     {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey]}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                                 parseFloat(item.price * exchangeRate) +
//                                 parseFloat(
//                                   (item.price * exchangeRate * item.tax) / 100
//                                 )
//                               ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                                 parseFloat(item.price * item.tax) / 100 +
//                                 parseFloat(item.price)
//                               ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   // State for dynamic columns
//   const [visibleColumns, setVisibleColumns] = useState(0); // 0 means no extra columns visible
//   const [columnNames, setColumnNames] = useState({
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });
//   const [isEditingColumnName, setIsEditingColumnName] = useState(null);
//   const [tempColumnName, setTempColumnName] = useState("");

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   // Function to add a new column
//   const handleAddColumn = () => {
//     if (visibleColumns < 6) {
//       setVisibleColumns(visibleColumns + 1);
//     }
//   };

//   // Function to start editing column name
//   const handleEditColumnName = (columnKey) => {
//     setIsEditingColumnName(columnKey);
//     setTempColumnName(columnNames[columnKey]);
//   };

//   // Function to save column name
//   const handleSaveColumnName = (columnKey) => {
//     if (tempColumnName.trim() !== "") {
//       setColumnNames({
//         ...columnNames,
//         [columnKey]: tempColumnName
//       });
//     }
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   // Function to cancel editing
//   const handleCancelEdit = () => {
//     setIsEditingColumnName(null);
//     setTempColumnName("");
//   };

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     // Export client details
//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   //category type get
//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // to get client details ---------------
//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   // get invoice no. ----------------------------
//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo);

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`;

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   // get current date---------------------------------------
//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       // CHANGE THIS - Check for projectName instead of type
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       alert(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   // submit data
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   // submit data
//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);

//           // CHANGE THIS LINE - Filter rows that have projectName instead of type
//           const filteredTableData = updatedTableData.filter(
//             (item) => item.projectName && item.projectName.trim() !== ""
//           );

//           console.log("FILTERED TABLE DATA:", filteredTableData); // ADD THIS TO DEBUG

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2),
//             notes: getData.notes,
//             totalTax: tax.toFixed(2),
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           console.log("submit data", requestData);

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           console.log(response.data);

//           if (response.data.status === "success") {
//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               col10: item.col10,
//               col11: item.col11,
//               col12: item.col12,
//               type: item.type || "", // Keep this for compatibility
//               quantity: item.quantity,
//               price: item.price,
//               tax: item.tax,
//               amount:
//                 item.amount !== ""
//                   ? item.amount
//                   : (
//                     parseFloat(item.price) * exchangeRate +
//                     parseFloat((item.price * exchangeRate * item.tax) / 100)
//                   ).toFixed(2),
//               rate:
//                 item.rate !== ""
//                   ? item.rate
//                   : (
//                     parseFloat(item.price) +
//                     parseFloat((item.price * item.tax) / 100)
//                   ).toFixed(2),
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                 100
//               ).toFixed(2),
//             }));

//             console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(invoicelistData, null, 2));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         // Don't fetch from backend - just use the invoice ID we already have
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${getinvoiceno}`);
//         }, 1000); // Small delay to ensure data is saved
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   // Net Total Logic
//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   // Map column keys to their display order
//   const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   return (
//     <>
//       <ToastContainer />
//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               {/* Add Column Button */}
//               {visibleColumns < 6 && (
//                 <div className="mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>

//                   {/* Dynamic columns */}
//                   {columnOrder.slice(0, visibleColumns).map((colKey, idx) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       {isEditingColumnName === colKey ? (
//                         <div className="d-flex align-items-center gap-1">
//                           <input
//                             type="text"
//                             className="form-control form-control-sm"
//                             value={tempColumnName}
//                             onChange={(e) => setTempColumnName(e.target.value)}
//                             onKeyPress={(e) => {
//                               if (e.key === 'Enter') {
//                                 handleSaveColumnName(colKey);
//                               }
//                             }}
//                             autoFocus
//                           />
//                           <button
//                             className="btn btn-success btn-sm p-1"
//                             onClick={() => handleSaveColumnName(colKey)}
//                           >
//                             <i className="fa-solid fa-check"></i>
//                           </button>
//                           <button
//                             className="btn btn-danger btn-sm p-1"
//                             onClick={handleCancelEdit}
//                           >
//                             <i className="fa-solid fa-times"></i>
//                           </button>
//                         </div>
//                       ) : (
//                         <div
//                           className="d-flex align-items-center justify-content-between"
//                           style={{ cursor: 'pointer' }}
//                           onClick={() => handleEditColumnName(colKey)}
//                         >
//                           <span>{columnNames[colKey]}</span>
//                           <i className="fa-solid fa-edit ms-1" style={{ fontSize: '12px' }}></i>
//                         </div>
//                       )}
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs */}
//                     {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey]}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   // State for dynamic columns
//   const [visibleColumns, setVisibleColumns] = useState(0);
//   const [columnNames, setColumnNames] = useState({
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });

//   // Modal state
//   const [showModal, setShowModal] = useState(false);
//   const [pendingColumnKey, setPendingColumnKey] = useState(null);
//   const [modalColumnName, setModalColumnName] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false); // New state to track if modal is in edit mode

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   // Function to add a new column - opens modal
//   const handleAddColumn = () => {
//     if (visibleColumns < 6) {
//       const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//       const nextColumnKey = columnOrder[visibleColumns];
//       setPendingColumnKey(nextColumnKey);
//       setModalColumnName(columnNames[nextColumnKey]);
//       setIsEditMode(false); // This is for adding a new column
//       setShowModal(true);
//     }
//   };

//   // Function to edit existing column name - opens modal
//   const handleEditColumn = (columnKey) => {
//     setPendingColumnKey(columnKey);
//     setModalColumnName(columnNames[columnKey]);
//     setIsEditMode(true); // This is for editing an existing column
//     setShowModal(true);
//   };

//   // Handle modal save
//   const handleModalSave = () => {
//     if (modalColumnName.trim() !== "" && pendingColumnKey) {
//       // Update column name
//       setColumnNames({
//         ...columnNames,
//         [pendingColumnKey]: modalColumnName
//       });

//       // Only increment visible columns if we're adding a new column
//       if (!isEditMode) {
//         setVisibleColumns(visibleColumns + 1);
//       }

//       // Close modal
//       setShowModal(false);
//       setModalColumnName("");
//       setPendingColumnKey(null);
//       setIsEditMode(false);
//     } else {
//       alert("Please enter a column name");
//     }
//   };

//   // Handle modal cancel
//   const handleModalCancel = () => {
//     setShowModal(false);
//     setModalColumnName("");
//     setPendingColumnKey(null);
//     setIsEditMode(false);
//   };

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo);

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`;

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       toast(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   // const submitdata = async () => {
//   //   const isValid = validateForm();
//   //   if (!isDataSubmitted) {
//   //     if (isValid) {
//   //       try {
//   //         setIsDataSubmitted(true);
//   //         const updatedTableData = [...tableData];
//   //         setTableData(updatedTableData);

//   //         const filteredTableData = updatedTableData.filter(
//   //           (item) => item.projectName && item.projectName.trim() !== ""
//   //         );

//   //         console.log("FILTERED TABLE DATA:", filteredTableData);

//   //         const newData = {
//   //           invoiceId: getinvoiceno,
//   //           clientName: selectedClient,
//   //           date: currentDate,
//   //           dueDate: getData.dueDate,
//   //           totalAmount: netTotal.toFixed(2),
//   //           notes: getData.notes,
//   //           totalTax: tax.toFixed(2),
//   //           paymentStatus: "Unpaid",
//   //           paymentDate: "",
//   //           getinvoicedatelabel: "",
//   //         };

//   //         const requestData = { ...getData, ...newData };

//   //         console.log("submit data", requestData);

//   //         const response = await axios.post(
//   //           apiUrl + "/invoicedetails",
//   //           requestData
//   //         );

//   //         console.log(response.data);

//   //         if (response.data.status === "success") {
//   //           const invoicelistData = filteredTableData.map((item) => ({
//   //             invoiceId: getinvoiceno,
//   //             date: item.date,
//   //             clientName: selectedClient,
//   //             projectName: item.projectName,
//   //             standard: item.standard,
//   //             premier: item.premier,
//   //             twilight: item.twilight,
//   //             day_to_dusk: item.day_to_dusk,
//   //             vra: item.vra,
//   //             vr: item.vr,
//   //             col7: item.col7,
//   //             col8: item.col8,
//   //             col9: item.col9,
//   //             col10: item.col10,
//   //             col11: item.col11,
//   //             col12: item.col12,
//   //             type: item.type || "",
//   //             quantity: item.quantity,
//   //             price: item.price,
//   //             tax: item.tax,
//   //             amount:
//   //               item.amount !== ""
//   //                 ? item.amount
//   //                 : (
//   //                   parseFloat(item.price) * exchangeRate +
//   //                   parseFloat((item.price * exchangeRate * item.tax) / 100)
//   //                 ).toFixed(2),
//   //             rate:
//   //               item.rate !== ""
//   //                 ? item.rate
//   //                 : (
//   //                   parseFloat(item.price) +
//   //                   parseFloat((item.price * item.tax) / 100)
//   //                 ).toFixed(2),
//   //             totalAmount: (
//   //               parseFloat(item.quantity) * parseFloat(item.price) +
//   //               (parseFloat(item.tax) *
//   //                 parseFloat(item.quantity) *
//   //                 parseFloat(item.price)) /
//   //               100
//   //             ).toFixed(2),
//   //           }));

//   //           console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(invoicelistData, null, 2));

//   //           try {
//   //             const response = await axios.post(
//   //               apiUrl + "/invoicelist",
//   //               invoicelistData
//   //             );
//   //             console.log("invoicelist data", response.data);
//   //             toaster(() => navigate("/invoice"));
//   //           } catch (err) {
//   //             console.log("Error in invoicelist request:", err);
//   //           }
//   //         } else {
//   //           console.log(
//   //             "Error in invoicedetails response:",
//   //             response.data.error
//   //           );
//   //         }
//   //       } catch (err) {
//   //         console.log("Error in submitdata function:", err);
//   //       }
//   //     } else {
//   //       console.log("Data has already been submitted");
//   //     }
//   //   }
//   // };

//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);

//           const filteredTableData = updatedTableData.filter(
//             (item) => item.projectName && item.projectName.trim() !== ""
//           );

//           console.log("FILTERED TABLE DATA:", filteredTableData);

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2), // Store in USD
//             notes: getData.notes,
//             totalTax: tax.toFixed(2), // Store in USD
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           console.log("submit data", requestData);

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           console.log(response.data);

//           if (response.data.status === "success") {
//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               col10: item.col10,
//               col11: item.col11,
//               col12: item.col12,
//               type: item.type || "",
//               quantity: item.quantity,
//               price: parseFloat(item.price).toFixed(2), // Store in USD
//               tax: item.tax,
//               // These fields can be removed or kept for legacy purposes
//               amount: "",
//               rate: "",
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                 100
//               ).toFixed(2), // Store in USD
//             }));

//             console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(invoicelistData, null, 2));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${getinvoiceno}`);
//         }, 1000);
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   return (
//     <>
//       <ToastContainer />

//       {/* Modal for naming/editing columns */}
//       {showModal && (
//         <div
//           className="modal fade show"
//           style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleModalCancel}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <label className="form-label">Column Name:</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={modalColumnName}
//                   onChange={(e) => setModalColumnName(e.target.value)}
//                   onKeyPress={(e) => {
//                     if (e.key === 'Enter') {
//                       handleModalSave();
//                     }
//                   }}
//                   placeholder="Enter column name"
//                   autoFocus
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={handleModalCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSave}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               {visibleColumns < 6 && (
//                 <div className="mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 </div>
//               )}
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>

//                   {/* Dynamic columns - now with edit icon */}
//                   {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       <div
//                         className="d-flex align-items-center justify-content-between"
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => handleEditColumn(colKey)}
//                         title="Click to edit column name"
//                       >
//                         <span>{columnNames[colKey]}</span>
//                         <i className="fa-solid fa-edit ms-1" style={{ fontSize: '12px' }}></i>
//                       </div>
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs */}
//                     {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey]}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   // State for dynamic columns
//   const [visibleColumns, setVisibleColumns] = useState(0);
//   const [columnNames, setColumnNames] = useState({
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });

//   // Modal state
//   const [showModal, setShowModal] = useState(false);
//   const [pendingColumnKey, setPendingColumnKey] = useState(null);
//   const [modalColumnName, setModalColumnName] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false); // New state to track if modal is in edit mode

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   // Function to add a new column - opens modal
//   const handleAddColumn = () => {
//     if (visibleColumns < 6) {
//       const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];
//       const nextColumnKey = columnOrder[visibleColumns];
//       setPendingColumnKey(nextColumnKey);
//       setModalColumnName(columnNames[nextColumnKey]);
//       setIsEditMode(false); // This is for adding a new column
//       setShowModal(true);
//     }
//   };

//   // Function to edit existing column name - opens modal
//   const handleEditColumn = (columnKey) => {
//     setPendingColumnKey(columnKey);
//     setModalColumnName(columnNames[columnKey]);
//     setIsEditMode(true); // This is for editing an existing column
//     setShowModal(true);
//   };

//   // Handle modal save
//   const handleModalSave = () => {
//     if (modalColumnName.trim() !== "" && pendingColumnKey) {
//       // Update column name
//       setColumnNames({
//         ...columnNames,
//         [pendingColumnKey]: modalColumnName
//       });

//       // Only increment visible columns if we're adding a new column
//       if (!isEditMode) {
//         setVisibleColumns(visibleColumns + 1);
//       }

//       // Close modal
//       setShowModal(false);
//       setModalColumnName("");
//       setPendingColumnKey(null);
//       setIsEditMode(false);
//     } else {
//       alert("Please enter a column name");
//     }
//   };

//   // Handle modal cancel
//   const handleModalCancel = () => {
//     setShowModal(false);
//     setModalColumnName("");
//     setPendingColumnKey(null);
//     setIsEditMode(false);
//   };

//   // Function to manually add a new row
//   const handleAddRow = () => {
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       col10: "",
//       col11: "",
//       col12: "",
//       type: "",
//       quantity: 1,
//       price: 0,
//       tax: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData([...tableData, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo);

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`;

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       toast(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);

//           const filteredTableData = updatedTableData.filter(
//             (item) => item.projectName && item.projectName.trim() !== ""
//           );

//           console.log("FILTERED TABLE DATA:", filteredTableData);

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2), // Store in USD
//             notes: getData.notes,
//             totalTax: tax.toFixed(2), // Store in USD
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           console.log("submit data", requestData);

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           console.log(response.data);

//           if (response.data.status === "success") {
//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               col10: item.col10,
//               col11: item.col11,
//               col12: item.col12,
//               type: item.type || "",
//               quantity: item.quantity,
//               price: parseFloat(item.price).toFixed(2), // Store in USD
//               tax: item.tax,
//               // These fields can be removed or kept for legacy purposes
//               amount: "",
//               rate: "",
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                 100
//               ).toFixed(2), // Store in USD
//             }));

//             console.log("DATA BEING SENT TO BACKEND:", JSON.stringify(invoicelistData, null, 2));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           } else {
//             console.log(
//               "Error in invoicedetails response:",
//               response.data.error
//             );
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       } else {
//         console.log("Data has already been submitted");
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${getinvoiceno}`);
//         }, 1000);
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   const columnOrder = ['col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   return (
//     <>
//       <ToastContainer />

//       {/* Modal for naming/editing columns */}
//       {showModal && (
//         <div
//           className="modal fade show"
//           style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleModalCancel}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <label className="form-label">Column Name:</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={modalColumnName}
//                   onChange={(e) => setModalColumnName(e.target.value)}
//                   onKeyPress={(e) => {
//                     if (e.key === 'Enter') {
//                       handleModalSave();
//                     }
//                   }}
//                   placeholder="Enter column name"
//                   autoFocus
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={handleModalCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSave}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               <div className="mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-success btn-sm mt-2 me-2"
//                   onClick={handleAddRow}
//                 >
//                   <i className="fa-solid fa-plus me-1"></i>
//                   Add Row
//                 </button>
//                 {visibleColumns < 6 && (
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 )}
//               </div>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>
//                   <th style={{ width: "4%" }}>Standard</th>
//                   <th style={{ width: "4%" }}>Primier</th>
//                   <th style={{ width: "4%" }}>Twilight</th>
//                   <th style={{ width: "7%" }}>Day to Dust</th>
//                   <th style={{ width: "4%" }}>VRA(5$)</th>
//                   <th style={{ width: "4%" }}>VR(12$)</th>

//                   {/* Dynamic columns - now with edit icon */}
//                   {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       <div
//                         className="d-flex align-items-center justify-content-between"
//                         style={{ cursor: 'pointer' }}
//                         onClick={() => handleEditColumn(colKey)}
//                         title="Click to edit column name"
//                       >
//                         <span>{columnNames[colKey]}</span>
//                         <i className="fa-solid fa-edit ms-1" style={{ fontSize: '12px' }}></i>
//                       </div>
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.standard}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "standard",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.premier}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "premier",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.twilight}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "twilight",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.day_to_dusk}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "day_to_dusk",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vra}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vra", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={item.vr}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "vr", e.target.value)
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs */}
//                     {columnOrder.slice(0, visibleColumns).map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey]}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import apiUrl from "../../Environment/Api";
// import { useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Invoiceadd() {
//   const navigate = useNavigate();
//   const [exchangeRate, setExchangeRate] = useState("");
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [getinvoiceno, setinvoiceno] = useState("");

//   const formatdateinvoice = new Date(currentDate);
//   const [getinvoicejustno, setinvoicejustno] = useState("");

//   // State for dynamic columns - ALL columns are now dynamic
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [columnNames, setColumnNames] = useState({
//     standard: "Standard",
//     premier: "Premier",
//     twilight: "Twilight",
//     day_to_dusk: "Day to Dusk",
//     vra: "VRA(5$)",
//     vr: "VR(12$)",
//     col7: "Column 7",
//     col8: "Column 8",
//     col9: "Column 9",
//     col10: "Column 10",
//     col11: "Column 11",
//     col12: "Column 12"
//   });

//   // Modal state
//   const [showModal, setShowModal] = useState(false);
//   const [pendingColumnKey, setPendingColumnKey] = useState(null);
//   const [modalColumnName, setModalColumnName] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);

//   useEffect(() => {
//     clientdetails();
//     invoiceno();
//     categorytype();
//     const fetchExchangeRate = async () => {
//       try {
//         const response = await fetch(
//           "https://api.frankfurter.app/latest?from=USD&to=INR"
//         );
//         const data = await response.json();
//         const usdToInrRate = data.rates.INR;

//         console.log("USD Amount :", usdToInrRate);
//         setExchangeRate(usdToInrRate);
//       } catch (error) {
//         console.error("Error fetching exchange rate:", error);
//       }
//     };
//     fetchExchangeRate();
//   }, [currentDate]);

//   const [selectedClient, setSelectedClient] = useState("");
//   const [tableData, setTableData] = useState([]);
//   const [subtotal, setSubtotal] = useState(0);
//   const [tax, setTax] = useState(0);
//   const [netTotal, setNetTotal] = useState(0);
//   const [clientRowCreated, setClientRowCreated] = useState(false);
//   const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

//   const [getclientaddress, setclientaddress] = useState("");
//   const [getclientcountry, setclientcountry] = useState("");
//   const [getclientName, setclientName] = useState("");
//   const [getclientmobile, setclientmobile] = useState("");

//   // Column order - all columns in sequence
//   const columnOrder = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

//   // Function to add a new column - opens modal
//   const handleAddColumn = () => {
//     const availableColumns = columnOrder.filter(col => !visibleColumns.includes(col));
//     if (availableColumns.length > 0) {
//       const nextColumnKey = availableColumns[0];
//       setPendingColumnKey(nextColumnKey);
//       setModalColumnName(columnNames[nextColumnKey]);
//       setIsEditMode(false);
//       setShowModal(true);
//     }
//   };

//   // Function to edit existing column name - opens modal
//   const handleEditColumn = (columnKey) => {
//     setPendingColumnKey(columnKey);
//     setModalColumnName(columnNames[columnKey]);
//     setIsEditMode(true);
//     setShowModal(true);
//   };

//   // Function to remove a column
//   const handleRemoveColumn = (columnKey) => {
//     if (window.confirm(`Are you sure you want to remove the "${columnNames[columnKey]}" column? This will clear all data in this column.`)) {
//       // Remove from visible columns
//       setVisibleColumns(visibleColumns.filter(col => col !== columnKey));

//       // Clear data from all rows for this column
//       const updatedTableData = tableData.map(row => ({
//         ...row,
//         [columnKey]: ""
//       }));
//       setTableData(updatedTableData);
//     }
//   };

//   // Handle modal save
//   const handleModalSave = () => {
//     if (modalColumnName.trim() !== "" && pendingColumnKey) {
//       // Update column name
//       setColumnNames({
//         ...columnNames,
//         [pendingColumnKey]: modalColumnName
//       });

//       // Only add to visible columns if we're adding a new column
//       if (!isEditMode) {
//         setVisibleColumns([...visibleColumns, pendingColumnKey]);
//       }

//       // Close modal
//       setShowModal(false);
//       setModalColumnName("");
//       setPendingColumnKey(null);
//       setIsEditMode(false);
//     } else {
//       toast("Please enter a column name");
//     }
//   };

//   // Handle modal cancel
//   const handleModalCancel = () => {
//     setShowModal(false);
//     setModalColumnName("");
//     setPendingColumnKey(null);
//     setIsEditMode(false);
//   };

//   // Function to manually add a new row
//   const handleAddRow = () => {
//     const newId = Date.now();
//     const newRow = {
//       id: newId,
//       date: getFormattedDate(),
//       projectName: "",
//       standard: "",
//       premier: "",
//       twilight: "",
//       day_to_dusk: "",
//       vra: "",
//       vr: "",
//       col7: "",
//       col8: "",
//       col9: "",
//       col10: "",
//       col11: "",
//       col12: "",
//       type: "",
//       quantity: 1,
//       price: 0,
//       tax: "",
//       amount: "",
//       rate: "",
//     };
//     setTableData([...tableData, newRow]);
//     setClientRowCreated(true);
//   };

//   const handleClientChange = async (event) => {
//     const clientValue = event.target.value;
//     setSelectedClient(clientValue);

//     const clientaddresscountryfilter = ClientDetails.filter(
//       (data) => data.id === parseInt(clientValue, 10)
//     );
//     setclientName(clientaddresscountryfilter[0].clientName);
//     setclientaddress(clientaddresscountryfilter[0].address);
//     setclientcountry(clientaddresscountryfilter[0].countrycode);
//     setclientmobile(clientaddresscountryfilter[0].mobile);

//     if (!clientRowCreated && clientValue !== "") {
//       const newId = Date.now();
//       const newDate = getFormattedDate();
//       setTableData([
//         {
//           id: newId,
//           date: newDate,
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         },
//       ]);
//       setClientRowCreated(true);
//     } else {
//       setClientRowCreated(false);
//     }
//   };

//   const [selectedType, setSelectedType] = useState({});
//   const handleTypeChange = (index, value) => {
//     if (value !== "") {
//       const updatedTableData = tableData.map((item, i) => {
//         if (i === index) {
//           const selectedTypeData = getCategoryType.find(
//             (category) => category.type === value
//           );

//           return {
//             ...item,
//             type: value,
//             price:
//               getclientcountry === "91"
//                 ? selectedTypeData.INRprice
//                 : selectedTypeData.price,
//           };
//         }
//         return item;
//       });

//       if (index === updatedTableData.length - 1) {
//         const newId = Date.now();
//         const newRow = {
//           id: newId,
//           date: getFormattedDate(),
//           projectName: "",
//           standard: "",
//           premier: "",
//           twilight: "",
//           day_to_dusk: "",
//           vra: "",
//           vr: "",
//           col7: "",
//           col8: "",
//           col9: "",
//           col10: "",
//           col11: "",
//           col12: "",
//           type: "",
//           quantity: 1,
//           price: 0,
//           tax: "",
//           amount: "",
//           rate: "",
//         };
//         updatedTableData.push(newRow);
//         setClientRowCreated(true);
//       }

//       setTableData(updatedTableData);
//     }
//   };

//   const handleUserInputChange = (index, property, value) => {
//     console.log("handleUserInputChange triggered:", index, property, value);
//     const updatedTableData = [...tableData];
//     updatedTableData[index][property] = value;
//     setTableData(updatedTableData);
//   };

//   useEffect(() => {
//     let newSubtotal = 0;
//     let newTax = 0;

//     tableData.forEach((item) => {
//       const quantity = parseFloat(item.quantity) || 0;
//       const price = parseFloat(item.price) || 0;
//       const itemSubtotal = quantity * price;
//       const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

//       newSubtotal += itemSubtotal;
//       newTax += itemTax;
//     });

//     setSubtotal(newSubtotal);
//     setTax(newTax);

//     const newNetTotal = newSubtotal + newTax;
//     setNetTotal(newNetTotal);
//   }, [clientRowCreated, selectedClient, tableData]);

//   const tablerowdelete = (ItemId) => {
//     setTableData((prevItems) => {
//       console.log("Before deletion:", prevItems);
//       const newItems = prevItems.filter((item) => item.id !== ItemId);
//       console.log("After deletion:", newItems);
//       return newItems;
//     });
//   };

//   const handleClearAll = () => {
//     setTableData([]);
//     setClientRowCreated(false);
//   };

//   const handleback = () => {
//     navigate("/invoice");
//   };

//   const [getCategoryType, setCategoryType] = useState([]);
//   const categorytype = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/category");
//       if (response) {
//         if (!response.length > 0) {
//           setCategoryType(response.data);
//           console.log("category type getted", response.data);
//         }
//       }
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const [ClientDetails, setClientDetails] = useState([]);
//   const clientdetails = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/clientdetailsfull");
//       if (response) {
//         setClientDetails(response.data);
//       }
//     } catch (error) {
//       console.error("Error fetching client details:", error);
//     }
//   };

//   const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

//   const invoiceno = async () => {
//     try {
//       const response = await axios.get(apiUrl + "/invoiceno");
//       console.log("the response for invoice no ---------------", response);

//       const updatedInvoiceJustNo = response.data.invoiceId;

//       setinvoicejustno(updatedInvoiceJustNo);

//       console.log("get invoice ----------------------", updatedInvoiceJustNo);

//       const formattedDate = `${formatdateinvoice
//         .getFullYear()
//         .toString()
//         .slice(-2)}${(formatdateinvoice.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}`;
//       setinvoicedatelabel(formattedDate);
//       const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`;

//       setinvoiceno(invoicedata);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   function getFormattedDate() {
//     const today = new Date();
//     const year = today.getFullYear();
//     let month = today.getMonth() + 1;
//     let day = today.getDate();

//     month = month < 10 ? `0${month}` : month;
//     day = day < 10 ? `0${day}` : day;

//     return `${year}-${month}-${day}`;
//   }

//   const validateForm = () => {
//     const emptyFields = [];
//     if (selectedClient === "") {
//       emptyFields.push("Client Name");
//     }
//     if (currentDate === "") {
//       emptyFields.push("Date");
//     }
//     if (getData.dueDate === "") {
//       emptyFields.push("Due Date");
//     }
//     if (tax === "") {
//       emptyFields.push("Tax");
//     }
//     tableData.forEach((item, index) => {
//       if (item.projectName && item.projectName.trim() !== "") {
//         if (item.tax === "") {
//           emptyFields.push(`Tax at row ${index + 1}`);
//         }
//         if (item.quantity === "") {
//           emptyFields.push(`Quantity at row ${index + 1}`);
//         }
//         if (item.price === "") {
//           emptyFields.push(`Price at row ${index + 1}`);
//         }
//       }
//     });
//     if (emptyFields.length > 0) {
//       toast(
//         `Please fill in the following required fields: ${emptyFields.join(
//           ", "
//         )}`
//       );
//       return false;
//     }
//     return true;
//   };

//   const [isDataSubmitted, setIsDataSubmitted] = useState(false);
//   const [getData, setData] = useState({
//     invoiceId: "",
//     clientName: "",
//     date: "",
//     dueDate: "",
//     notes: "",
//     totalTax: "",
//     paymentStatus: "Unpaid",
//     totalAmount: "",
//     paymentDate: "",
//     getinvoicedatelabel: "",
//   });

//   const toaster = (callback) => {
//     toast.success("Data submitted successfully!", {
//       autoClose: 1000,
//       hideProgressBar: true,
//       onClose: callback,
//     });
//   };

//   const submitdata = async () => {
//     const isValid = validateForm();
//     if (!isDataSubmitted) {
//       if (isValid) {
//         try {
//           setIsDataSubmitted(true);
//           const updatedTableData = [...tableData];
//           setTableData(updatedTableData);

//           const filteredTableData = updatedTableData.filter(
//             (item) => item.projectName && item.projectName.trim() !== ""
//           );

//           const newData = {
//             invoiceId: getinvoiceno,
//             clientName: selectedClient,
//             date: currentDate,
//             dueDate: getData.dueDate,
//             totalAmount: netTotal.toFixed(2),
//             notes: getData.notes,
//             totalTax: tax.toFixed(2),
//             paymentStatus: "Unpaid",
//             paymentDate: "",
//             getinvoicedatelabel: "",
//           };

//           const requestData = { ...getData, ...newData };

//           const response = await axios.post(
//             apiUrl + "/invoicedetails",
//             requestData
//           );

//           if (response.data.status === "success") {
//             // **NEW: Save column configuration**
//             const columnConfig = {
//               invoiceId: getinvoiceno,
//               clientName: selectedClient,
//               ...columnNames
//             };

//             try {
//               await axios.post(apiUrl + "/invoice-columns", columnConfig);
//               console.log("Column configuration saved");
//             } catch (err) {
//               console.error("Error saving column configuration:", err);
//             }

//             const invoicelistData = filteredTableData.map((item) => ({
//               invoiceId: getinvoiceno,
//               date: item.date,
//               clientName: selectedClient,
//               projectName: item.projectName,
//               standard: item.standard,
//               premier: item.premier,
//               twilight: item.twilight,
//               day_to_dusk: item.day_to_dusk,
//               vra: item.vra,
//               vr: item.vr,
//               col7: item.col7,
//               col8: item.col8,
//               col9: item.col9,
//               col10: item.col10,
//               col11: item.col11,
//               col12: item.col12,
//               type: item.type || "",
//               quantity: item.quantity,
//               price: parseFloat(item.price).toFixed(2),
//               tax: item.tax,
//               amount: "",
//               rate: "",
//               totalAmount: (
//                 parseFloat(item.quantity) * parseFloat(item.price) +
//                 (parseFloat(item.tax) *
//                   parseFloat(item.quantity) *
//                   parseFloat(item.price)) /
//                 100
//               ).toFixed(2),
//             }));

//             try {
//               const response = await axios.post(
//                 apiUrl + "/invoicelist",
//                 invoicelistData
//               );
//               console.log("invoicelist data", response.data);
//               toaster(() => navigate("/invoice"));
//             } catch (err) {
//               console.log("Error in invoicelist request:", err);
//             }
//           }
//         } catch (err) {
//           console.log("Error in submitdata function:", err);
//         }
//       }
//     }
//   };

//   const handlenavigate = async () => {
//     const isValid = validateForm();
//     if (isValid) {
//       try {
//         await submitdata();
//         setTimeout(() => {
//           navigate(`/invoice/invoiceprint/${getinvoiceno}`);
//         }, 1000);
//       } catch (error) {
//         console.error("Error submitting data and navigating:", error);
//       }
//     }
//   };

//   const [storedNetTotal, setStoredNetTotal] = useState(0);

//   useEffect(() => {
//     let finalAmount = 0;

//     if (getclientcountry === "91") {
//       finalAmount = netTotal * exchangeRate;
//     } else {
//       finalAmount = netTotal;
//     }

//     setStoredNetTotal(finalAmount);
//   }, [netTotal, getclientcountry, exchangeRate]);

//   return (
//     <>
//       <ToastContainer />

//       {/* Modal for naming/editing columns */}
//       {showModal && (
//         <div
//           className="modal fade show"
//           style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//           tabIndex="-1"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">
//                   {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={handleModalCancel}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 <label className="form-label">Column Name:</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={modalColumnName}
//                   onChange={(e) => setModalColumnName(e.target.value)}
//                   onKeyPress={(e) => {
//                     if (e.key === 'Enter') {
//                       handleModalSave();
//                     }
//                   }}
//                   placeholder="Enter column name"
//                   autoFocus
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn btn-secondary"
//                   onClick={handleModalCancel}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary"
//                   onClick={handleModalSave}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <h3 className="text-center">Invoice</h3>
//       <hr />
//       <div className="mx-1">
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Invoice No.</label>
//               <input
//                 className="form-control"
//                 value={getinvoiceno}
//                 type="text"
//               ></input>
//             </div>
//             <div className="col-lg-6 col-md-4"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <label className="form-label">Date :</label>
//               <input
//                 className="form-control"
//                 type="date"
//                 value={currentDate}
//                 onChange={(e) => setCurrentDate(e.target.value)}
//                 required
//               />
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <form className="row">
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <div className="dropdown">
//                 <label className="form-label">Client Name :</label>
//                 <div className="position-relative">
//                   <select
//                     className="form-control dropdown-toggle custom-select"
//                     value={selectedClient}
//                     onChange={handleClientChange}
//                   >
//                     <option value="">Select an option</option>
//                     {ClientDetails.map((item) => (
//                       <option key={item.id} value={item.id}>
//                         {item.clientName}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="dropdown-arrow"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4">
//               <div className="mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-success btn-sm mt-2 me-2"
//                   onClick={handleAddRow}
//                 >
//                   <i className="fa-solid fa-plus me-1"></i>
//                   Add Row
//                 </button>
//                 {visibleColumns.length < 12 && (
//                   <button
//                     type="button"
//                     className="btn btn-primary btn-sm mt-2"
//                     onClick={handleAddColumn}
//                   >
//                     <i className="fa-solid fa-plus me-1"></i>
//                     Add Column
//                   </button>
//                 )}
//               </div>
//             </div>
//             <div className="col-lg-3"></div>
//             <div className="col-lg-3 col-md-4 col-sm-12">
//               <form className="control">
//                 <label className="form-label">Due Date</label>
//                 <input
//                   className="form-control"
//                   value={getData.dueDate}
//                   type="date"
//                   onChange={(e) => {
//                     setData({ ...getData, dueDate: e.target.value });
//                   }}
//                   required
//                 />
//               </form>
//             </div>
//           </form>
//         </div>
//         <div className="invoicebackground1">
//           <div className="table-responsive">
//             <table className="table table-bordered">
//               <thead className="font-size">
//                 <tr>
//                   <th>S.No</th>
//                   <th style={{ width: "0%" }}>Date</th>
//                   <th style={{ width: "15%" }}>Address</th>

//                   {/* Dynamic columns - now ALL columns after Address are dynamic */}
//                   {visibleColumns.map((colKey) => (
//                     <th key={colKey} style={{ width: "4%" }}>
//                       <div
//                         className="d-flex align-items-center justify-content-between"
//                         style={{ gap: '5px' }}
//                       >
//                         <span
//                           style={{ cursor: 'pointer', flex: 1 }}
//                           onClick={() => handleEditColumn(colKey)}
//                           title="Click to edit column name"
//                         >
//                           {columnNames[colKey]}
//                         </span>
//                         <i
//                           className="fa-solid fa-edit"
//                           style={{ fontSize: '12px', cursor: 'pointer' }}
//                           onClick={() => handleEditColumn(colKey)}
//                           title="Edit column name"
//                         ></i>
//                         <i
//                           className="fa-solid fa-trash text-danger"
//                           style={{ fontSize: '12px', cursor: 'pointer' }}
//                           onClick={() => handleRemoveColumn(colKey)}
//                           title="Remove column"
//                         ></i>
//                       </div>
//                     </th>
//                   ))}

//                   <th style={{ width: "5%" }}>$ Price</th>
//                   <th style={{ width: "5%" }}>Tax</th>
//                   <th style={{ width: "7%" }}>₹ Amount</th>
//                   <th style={{ width: "7%" }}>$ Rate</th>
//                   <th>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((item, index) => (
//                   <tr key={item.id}>
//                     <th scope="row">{index + 1}</th>
//                     <td>
//                       <input
//                         style={{ width: "80%" }}
//                         className="form-control pe-0"
//                         type="date"
//                         value={item.date}
//                         onChange={(e) =>
//                           handleUserInputChange(index, "date", e.target.value)
//                         }
//                       />
//                     </td>
//                     <td>
//                       <input
//                         style={{ width: "100%" }}
//                         className="form-control"
//                         type="text"
//                         value={item.projectName}
//                         onChange={(e) =>
//                           handleUserInputChange(
//                             index,
//                             "projectName",
//                             e.target.value
//                           )
//                         }
//                       />
//                     </td>

//                     {/* Dynamic column inputs - render based on visible columns */}
//                     {visibleColumns.map((colKey) => (
//                       <td key={colKey}>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={item[colKey]}
//                           onChange={(e) =>
//                             handleUserInputChange(index, colKey, e.target.value)
//                           }
//                         />
//                       </td>
//                     ))}

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.price}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "price", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control"
//                         type="tel"
//                         value={item.tax}
//                         placeholder="Tax"
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           const onlyNumbers = value.replace(/[^0-9]/g, "");
//                           handleUserInputChange(index, "tax", onlyNumbers);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         className="form-control ps-2"
//                         value={
//                           item.amount !== undefined && item.amount !== ""
//                             ? item.amount
//                             : (
//                               parseFloat(item.price * exchangeRate) +
//                               parseFloat(
//                                 (item.price * exchangeRate * item.tax) / 100
//                               )
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "amount", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <input
//                         className="form-control ps-2"
//                         placeholder="rate"
//                         value={
//                           item.rate !== undefined && item.rate !== ""
//                             ? item.rate
//                             : (
//                               parseFloat(item.price * item.tax) / 100 +
//                               parseFloat(item.price)
//                             ).toFixed(2)
//                         }
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9.]/g, "");
//                           handleUserInputChange(index, "rate", value);
//                         }}
//                       />
//                     </td>

//                     <td>
//                       <button
//                         className="btn btn-danger px-1 py-1 d-flex align-items-center"
//                         onClick={() => tablerowdelete(item.id)}
//                       >
//                         <i className="fa-solid fa-trash"></i>
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="row mt-4">
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <label className="form-label">
//                 <b>Notes :</b>
//                 <br />
//                 <textarea
//                   className="form-control notes-textarea"
//                   type="text"
//                   value={getData.notes}
//                   onChange={(e) => {
//                     setData({ ...getData, notes: e.target.value });
//                   }}
//                   required
//                 />
//               </label>
//             </div>
//             <div className="col-lg-6 col-md-6 col-sm-12">
//               <form>
//                 <div className=" row">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Sub Total</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${subtotal.toFixed(2)}`
//                           : `${subtotal.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Sub Total"
//                     />
//                   </div>
//                 </div>
//                 <div className=" row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Paypal Tax</b>
//                     </label>
//                   </div>
//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${tax.toFixed(2)}`
//                           : `${tax.toFixed(2)}`
//                       }
//                       type="text"
//                       placeholder="Tax"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mt-3">
//                   <div className="col-lg-5 col-md-6 mt-1">
//                     <label className="form-label">
//                       <b>Net Total</b>
//                     </label>
//                   </div>

//                   <div className="col-lg-7 col-md-6">
//                     <input
//                       className="form-control"
//                       type="text"
//                       placeholder="Net Total"
//                       value={
//                         getclientcountry === "91"
//                           ? `₹${Math.round(storedNetTotal).toFixed(2)}`
//                           : `${Math.round(storedNetTotal).toFixed(2)}`
//                       }
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-lg-5"></div>
//             <div className="col-lg-7">
//               <div
//                 style={{ marginLeft: "75px" }}
//                 className="d-flex justify-content-evenly mt-3 buttonstyle "
//               >
//                 <button
//                   type="button"
//                   className="btn btn-danger invoice-button"
//                   onClick={handleClearAll}
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-info text-white invoice-button"
//                   style={{ backgroundColor: "#007BFF" }}
//                   onClick={handleback}
//                 >
//                   Back
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-success invoice-button"
//                   onClick={submitdata}
//                 >
//                   Save
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-secondary invoice-button"
//                   onClick={handlenavigate}
//                 >
//                   Print
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }
// export default Invoiceadd;


import React, { useState, useEffect } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Invoiceadd() {
  const navigate = useNavigate();
  const [exchangeRate, setExchangeRate] = useState("");
  const [currentDate, setCurrentDate] = useState(getFormattedDate());
  const [getinvoiceno, setinvoiceno] = useState("");

  const formatdateinvoice = new Date(currentDate);
  const [getinvoicejustno, setinvoicejustno] = useState("");

  // State for dynamic columns - ALL columns are now dynamic
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [columnNames, setColumnNames] = useState({
    standard: "Standard",
    premier: "Premier",
    twilight: "Twilight",
    day_to_dusk: "Day to Dusk",
    vra: "VRA(5$)",
    vr: "VR(12$)",
    col7: "Column 7",
    col8: "Column 8",
    col9: "Column 9",
    col10: "Column 10",
    col11: "Column 11",
    col12: "Column 12"
  });

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [pendingColumnKey, setPendingColumnKey] = useState(null);
  const [modalColumnName, setModalColumnName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    clientdetails();
    invoiceno();
    categorytype();
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch(
          "https://api.frankfurter.app/latest?from=USD&to=INR"
        );
        const data = await response.json();
        const usdToInrRate = data.rates.INR;

        console.log("USD Amount :", usdToInrRate);
        setExchangeRate(usdToInrRate);
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
      }
    };
    fetchExchangeRate();
  }, [currentDate]);

  const [selectedClient, setSelectedClient] = useState("");
  const [tableData, setTableData] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [netTotal, setNetTotal] = useState(0);
  const [clientRowCreated, setClientRowCreated] = useState(false);
  const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);

  const [getclientaddress, setclientaddress] = useState("");
  const [getclientcountry, setclientcountry] = useState("");
  const [getclientName, setclientName] = useState("");
  const [getclientmobile, setclientmobile] = useState("");

  // Column order - all columns in sequence
  const columnOrder = ['standard', 'premier', 'twilight', 'day_to_dusk', 'vra', 'vr', 'col7', 'col8', 'col9', 'col10', 'col11', 'col12'];

  // Function to add a new column - opens modal
  const handleAddColumn = () => {
    const availableColumns = columnOrder.filter(col => !visibleColumns.includes(col));
    if (availableColumns.length > 0) {
      const nextColumnKey = availableColumns[0];
      setPendingColumnKey(nextColumnKey);
      setModalColumnName(columnNames[nextColumnKey]);
      setIsEditMode(false);
      setShowModal(true);
    }
  };

  // Function to edit existing column name - opens modal
  const handleEditColumn = (columnKey) => {
    setPendingColumnKey(columnKey);
    setModalColumnName(columnNames[columnKey]);
    setIsEditMode(true);
    setShowModal(true);
  };

  // Function to remove a column
  const handleRemoveColumn = (columnKey) => {
    if (window.confirm(`Are you sure you want to remove the "${columnNames[columnKey]}" column? This will clear all data in this column.`)) {
      // Remove from visible columns
      setVisibleColumns(visibleColumns.filter(col => col !== columnKey));

      // Clear data from all rows for this column
      const updatedTableData = tableData.map(row => ({
        ...row,
        [columnKey]: ""
      }));
      setTableData(updatedTableData);
    }
  };

  // Handle modal save
  const handleModalSave = () => {
    if (modalColumnName.trim() !== "" && pendingColumnKey) {
      // Update column name
      setColumnNames({
        ...columnNames,
        [pendingColumnKey]: modalColumnName
      });

      // Only add to visible columns if we're adding a new column
      if (!isEditMode) {
        setVisibleColumns([...visibleColumns, pendingColumnKey]);
      }

      // Close modal
      setShowModal(false);
      setModalColumnName("");
      setPendingColumnKey(null);
      setIsEditMode(false);
    } else {
      toast("Please enter a column name");
    }
  };

  // Handle modal cancel
  const handleModalCancel = () => {
    setShowModal(false);
    setModalColumnName("");
    setPendingColumnKey(null);
    setIsEditMode(false);
  };

  // Function to manually add a new row
  const handleAddRow = () => {
    const newId = Date.now();
    const newRow = {
      id: newId,
      date: getFormattedDate(),
      projectName: "",
      standard: "",
      premier: "",
      twilight: "",
      day_to_dusk: "",
      vra: "",
      vr: "",
      col7: "",
      col8: "",
      col9: "",
      col10: "",
      col11: "",
      col12: "",
      type: "",
      quantity: 1,
      price: 0,
      tax: "",
      amount: "",
      rate: "",
    };
    setTableData([...tableData, newRow]);
    setClientRowCreated(true);
  };

  const handleClientChange = async (event) => {
    const clientValue = event.target.value;
    setSelectedClient(clientValue);

    const clientaddresscountryfilter = ClientDetails.filter(
      (data) => data.id === parseInt(clientValue, 10)
    );
    setclientName(clientaddresscountryfilter[0].clientName);
    setclientaddress(clientaddresscountryfilter[0].address);
    setclientcountry(clientaddresscountryfilter[0].countrycode);
    setclientmobile(clientaddresscountryfilter[0].mobile);

    if (!clientRowCreated && clientValue !== "") {
      const newId = Date.now();
      const newDate = getFormattedDate();
      setTableData([
        {
          id: newId,
          date: newDate,
          projectName: "",
          standard: "",
          premier: "",
          twilight: "",
          day_to_dusk: "",
          vra: "",
          vr: "",
          col7: "",
          col8: "",
          col9: "",
          col10: "",
          col11: "",
          col12: "",
          type: "",
          quantity: 1,
          price: 0,
          tax: "",
          amount: "",
          rate: "",
        },
      ]);
      setClientRowCreated(true);
    } else {
      setClientRowCreated(false);
    }
  };

  const [selectedType, setSelectedType] = useState({});
  const handleTypeChange = (index, value) => {
    if (value !== "") {
      const updatedTableData = tableData.map((item, i) => {
        if (i === index) {
          const selectedTypeData = getCategoryType.find(
            (category) => category.type === value
          );

          return {
            ...item,
            type: value,
            price:
              getclientcountry === "91"
                ? selectedTypeData.INRprice
                : selectedTypeData.price,
          };
        }
        return item;
      });

      if (index === updatedTableData.length - 1) {
        const newId = Date.now();
        const newRow = {
          id: newId,
          date: getFormattedDate(),
          projectName: "",
          standard: "",
          premier: "",
          twilight: "",
          day_to_dusk: "",
          vra: "",
          vr: "",
          col7: "",
          col8: "",
          col9: "",
          col10: "",
          col11: "",
          col12: "",
          type: "",
          quantity: 1,
          price: 0,
          tax: "",
          amount: "",
          rate: "",
        };
        updatedTableData.push(newRow);
        setClientRowCreated(true);
      }

      setTableData(updatedTableData);
    }
  };

  const handleUserInputChange = (index, property, value) => {
    console.log("handleUserInputChange triggered:", index, property, value);
    const updatedTableData = [...tableData];
    updatedTableData[index][property] = value;
    setTableData(updatedTableData);
  };

  useEffect(() => {
    let newSubtotal = 0;
    let newTax = 0;

    tableData.forEach((item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const price = parseFloat(item.price) || 0;
      const itemSubtotal = quantity * price;
      const itemTax = ((parseFloat(item.tax) || 0) * itemSubtotal) / 100;

      newSubtotal += itemSubtotal;
      newTax += itemTax;
    });

    setSubtotal(newSubtotal);
    setTax(newTax);

    const newNetTotal = newSubtotal + newTax;
    setNetTotal(newNetTotal);
  }, [clientRowCreated, selectedClient, tableData]);

  const tablerowdelete = (ItemId) => {
    setTableData((prevItems) => {
      console.log("Before deletion:", prevItems);
      const newItems = prevItems.filter((item) => item.id !== ItemId);
      console.log("After deletion:", newItems);
      return newItems;
    });
  };

  const handleClearAll = () => {
    setTableData([]);
    setClientRowCreated(false);
  };

  const handleback = () => {
    navigate("/invoice");
  };

  const [getCategoryType, setCategoryType] = useState([]);
  const categorytype = async () => {
    try {
      const response = await axios.get(apiUrl + "/category");
      if (response) {
        if (!response.length > 0) {
          setCategoryType(response.data);
          console.log("category type getted", response.data);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [ClientDetails, setClientDetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetailsfull");
      if (response) {
        setClientDetails(response.data);
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  const [getinvoicedatelabel, setinvoicedatelabel] = useState("");

  const invoiceno = async () => {
    try {
      const response = await axios.get(apiUrl + "/invoiceno");
      console.log("the response for invoice no ---------------", response);

      const updatedInvoiceJustNo = response.data.invoiceId;

      setinvoicejustno(updatedInvoiceJustNo);

      console.log("get invoice ----------------------", updatedInvoiceJustNo);

      const formattedDate = `${formatdateinvoice
        .getFullYear()
        .toString()
        .slice(-2)}${(formatdateinvoice.getMonth() + 1)
          .toString()
          .padStart(2, "0")}`;
      setinvoicedatelabel(formattedDate);
      const invoicedata = `CLICKON${formattedDate}-${updatedInvoiceJustNo}`;

      setinvoiceno(invoicedata);
    } catch (err) {
      console.log(err);
    }
  };

  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
  }

  const validateForm = () => {
    const emptyFields = [];
    if (selectedClient === "") {
      emptyFields.push("Client Name");
    }
    if (currentDate === "") {
      emptyFields.push("Date");
    }
    if (getData.dueDate === "") {
      emptyFields.push("Due Date");
    }
    if (tax === "") {
      emptyFields.push("Tax");
    }
    // tableData.forEach((item, index) => {
    //   // if (item.projectName && item.projectName.trim() !== "") {
    //   //   if (item.tax === "") {
    //   //     emptyFields.push(`Tax at row ${index + 1}`);
    //   //   }
    //   //   if (item.quantity === "") {
    //   //     emptyFields.push(`Quantity at row ${index + 1}`);
    //   //   }
    //   //   if (item.price === "") {
    //   //     emptyFields.push(`Price at row ${index + 1}`);
    //   //   }
    //   // }
    // });
    if (emptyFields.length > 0) {
      toast(
        `Please fill in the following required fields: ${emptyFields.join(
          ", "
        )}`
      );
      return false;
    }
    return true;
  };

  const [isDataSubmitted, setIsDataSubmitted] = useState(false);
  const [getData, setData] = useState({
    invoiceId: "",
    clientName: "",
    date: "",
    dueDate: "",
    notes: "",
    totalTax: "",
    paymentStatus: "Unpaid",
    totalAmount: "",
    paymentDate: "",
    getinvoicedatelabel: "",
  });

  const toaster = (callback) => {
    toast.success("Data submitted successfully!", {
      autoClose: 1000,
      hideProgressBar: true,
      onClose: callback,
    });
  };

  const submitdata = async () => {
    const isValid = validateForm();
    if (!isDataSubmitted) {
      if (isValid) {
        try {
          setIsDataSubmitted(true);
          const updatedTableData = [...tableData];
          setTableData(updatedTableData);

          const filteredTableData = updatedTableData.filter(
            (item) => item.projectName && item.projectName.trim() !== ""
          );

          const newData = {
            invoiceId: getinvoiceno,
            clientName: selectedClient,
            date: currentDate,
            dueDate: getData.dueDate,
            totalAmount: netTotal.toFixed(2),
            notes: getData.notes,
            totalTax: tax.toFixed(2),
            paymentStatus: "Unpaid",
            paymentDate: "",
            getinvoicedatelabel: "",
          };

          const requestData = { ...getData, ...newData };

          const response = await axios.post(
            apiUrl + "/invoicedetails",
            requestData
          );

          if (response.data.status === "success") {
            // **NEW: Save column configuration**
            const columnConfig = {
              invoiceId: getinvoiceno,
              clientName: selectedClient,
              ...columnNames
            };

            try {
              await axios.post(apiUrl + "/invoice-columns", columnConfig);
              console.log("Column configuration saved");
            } catch (err) {
              console.error("Error saving column configuration:", err);
            }

            const invoicelistData = filteredTableData.map((item) => ({
              invoiceId: getinvoiceno,
              date: item.date,
              clientName: selectedClient,
              projectName: item.projectName,
              standard: item.standard,
              premier: item.premier,
              twilight: item.twilight,
              day_to_dusk: item.day_to_dusk,
              vra: item.vra,
              vr: item.vr,
              col7: item.col7,
              col8: item.col8,
              col9: item.col9,
              col10: item.col10,
              col11: item.col11,
              col12: item.col12,
              type: item.type || "",
              quantity: item.quantity,
              price: parseFloat(item.price).toFixed(2),
              tax: item.tax,
              amount: "",
              rate: "",
              totalAmount: (
                parseFloat(item.quantity) * parseFloat(item.price) +
                (parseFloat(item.tax) *
                  parseFloat(item.quantity) *
                  parseFloat(item.price)) /
                100
              ).toFixed(2),
            }));

            try {
              const response = await axios.post(
                apiUrl + "/invoicelist",
                invoicelistData
              );
              console.log("invoicelist data", response.data);
              toaster(() => navigate("/invoice"));
            } catch (err) {
              console.log("Error in invoicelist request:", err);
            }
          }
        } catch (err) {
          console.log("Error in submitdata function:", err);
        }
      }
    }
  };

  const handlenavigate = async () => {
    const isValid = validateForm();
    if (isValid) {
      try {
        await submitdata();
        setTimeout(() => {
          navigate(`/invoice/invoiceprint/${getinvoiceno}`);
        }, 1000);
      } catch (error) {
        console.error("Error submitting data and navigating:", error);
      }
    }
  };

  const [storedNetTotal, setStoredNetTotal] = useState(0);

  useEffect(() => {
    let finalAmount = 0;

    if (getclientcountry === "91") {
      finalAmount = netTotal * exchangeRate;
    } else {
      finalAmount = netTotal;
    }

    setStoredNetTotal(finalAmount);
  }, [netTotal, getclientcountry, exchangeRate]);

  return (
    <>
      <ToastContainer />

      {/* Modal for naming/editing columns */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? 'Edit Column Name' : 'Name Your Column'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleModalCancel}
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Column Name:</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalColumnName}
                  onChange={(e) => setModalColumnName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleModalSave();
                    }
                  }}
                  placeholder="Enter column name"
                  autoFocus
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleModalCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleModalSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <h3 className="text-center">Invoice</h3>
      <hr />
      <div className="mx-1">
        <div className="invoicebackground1">
          <form className="row">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Invoice No.</label>
              <input
                className="form-control"
                value={getinvoiceno}
                type="text"
              ></input>
            </div>
            <div className="col-lg-6 col-md-4"></div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <label className="form-label">Date :</label>
              <input
                className="form-control"
                type="date"
                value={currentDate}
                onChange={(e) => setCurrentDate(e.target.value)}
                required
              />
            </div>
          </form>
        </div>
        <div className="invoicebackground1">
          <form className="row">
            <div className="col-lg-3 col-md-4 col-sm-12">
              <div className="dropdown">
                <label className="form-label">Client Name :</label>
                <div className="position-relative">
                  <select
                    className="form-control dropdown-toggle custom-select"
                    value={selectedClient}
                    onChange={handleClientChange}
                  >
                    <option value="">Select an option</option>
                    {ClientDetails.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.clientName}
                      </option>
                    ))}
                  </select>
                  <div className="dropdown-arrow"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4">
              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-success btn-sm mt-2 me-2"
                  onClick={handleAddRow}
                >
                  <i className="fa-solid fa-plus me-1"></i>
                  Add Row
                </button>
                {visibleColumns.length < 12 && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mt-2"
                    onClick={handleAddColumn}
                  >
                    <i className="fa-solid fa-plus me-1"></i>
                    Add Column
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-3"></div>
            <div className="col-lg-3 col-md-4 col-sm-12">
              <form className="control">
                <label className="form-label">Due Date</label>
                <input
                  className="form-control"
                  value={getData.dueDate}
                  type="date"
                  onChange={(e) => {
                    setData({ ...getData, dueDate: e.target.value });
                  }}
                  required
                />
              </form>
            </div>
          </form>
        </div>
        <div className="invoicebackground1">
          {/* **FIXED: Added wrapper with fixed width and horizontal scroll** */}
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <table className="table table-bordered" style={{ minWidth: '1400px', tableLayout: 'fixed' }}>
              <thead className="font-size">
                <tr>
                  <th style={{ width: "50px" }}>S.No</th>
                  <th style={{ width: "120px" }}>Date</th>
                  <th style={{ width: "150px" }}>Address</th>

                  {/* Dynamic columns - now ALL columns after Address are dynamic */}
                  {visibleColumns.map((colKey) => (
                    <th key={colKey} style={{ width: "70px" }}>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: '5px', overflow: 'hidden' }}
                      >
                        <span
                          style={{ 
                            cursor: 'pointer', 
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                          onClick={() => handleEditColumn(colKey)}
                          title={columnNames[colKey]}
                        >
                          {columnNames[colKey]}
                        </span>
                        <i
                          className="fa-solid fa-edit"
                          style={{ fontSize: '12px', cursor: 'pointer', flexShrink: 0 }}
                          onClick={() => handleEditColumn(colKey)}
                          title="Edit column name"
                        ></i>
                        <i
                          className="fa-solid fa-trash text-danger"
                          style={{ fontSize: '12px', cursor: 'pointer', flexShrink: 0 }}
                          onClick={() => handleRemoveColumn(colKey)}
                          title="Remove column"
                        ></i>
                      </div>
                    </th>
                  ))}

                  <th style={{ width: "70px" }}>$ Price</th>
                  <th style={{ width: "70px" }}>Tax</th>
                  <th style={{ width: "88px" }}>₹ Amount</th>
                  <th style={{ width: "75px" }}>$ Rate</th>
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <input
                        style={{ width: "100%" }}
                        className="form-control pe-0"
                        type="date"
                        value={item.date}
                        onChange={(e) =>
                          handleUserInputChange(index, "date", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        style={{ width: "100%" }}
                        className="form-control"
                        type="text"
                        value={item.projectName}
                        onChange={(e) =>
                          handleUserInputChange(
                            index,
                            "projectName",
                            e.target.value
                          )
                        }
                      />
                    </td>

                    {/* Dynamic column inputs - render based on visible columns */}
                    {visibleColumns.map((colKey) => (
                      <td key={colKey}>
                        <input
                          className="form-control"
                          type="text"
                          value={item[colKey]}
                          onChange={(e) =>
                            handleUserInputChange(index, colKey, e.target.value)
                          }
                        />
                      </td>
                    ))}

                    <td>
                      <input
                        className="form-control"
                        type="tel"
                        value={item.price}
                        onChange={(e) => {
                          const value = e.target.value;
                          const onlyNumbers = value.replace(/[^0-9]/g, "");
                          handleUserInputChange(index, "price", onlyNumbers);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        className="form-control"
                        type="tel"
                        value={item.tax}
                        placeholder="Tax"
                        onChange={(e) => {
                          const value = e.target.value;
                          const onlyNumbers = value.replace(/[^0-9]/g, "");
                          handleUserInputChange(index, "tax", onlyNumbers);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        className="form-control ps-2"
                        value={
                          item.amount !== undefined && item.amount !== ""
                            ? item.amount
                            : (
                              parseFloat(item.price * exchangeRate) +
                              parseFloat(
                                (item.price * exchangeRate * item.tax) / 100
                              )
                            ).toFixed(2)
                        }
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleUserInputChange(index, "amount", value);
                        }}
                      />
                    </td>

                    <td>
                      <input
                        className="form-control ps-2"
                        placeholder="rate"
                        value={
                          item.rate !== undefined && item.rate !== ""
                            ? item.rate
                            : (
                              parseFloat(item.price * item.tax) / 100 +
                              parseFloat(item.price)
                            ).toFixed(2)
                        }
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9.]/g, "");
                          handleUserInputChange(index, "rate", value);
                        }}
                      />
                    </td>

                    <td>
                      <button
                        className="btn btn-danger px-1 py-1 d-flex align-items-center"
                        onClick={() => tablerowdelete(item.id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="row mt-4">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <label className="form-label">
                <b>Notes :</b>
                <br />
                <textarea
                  className="form-control notes-textarea"
                  type="text"
                  value={getData.notes}
                  onChange={(e) => {
                    setData({ ...getData, notes: e.target.value });
                  }}
                  required
                />
              </label>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <form>
                <div className=" row">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Sub Total</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹${subtotal.toFixed(2)}`
                          : `${subtotal.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Sub Total"
                    />
                  </div>
                </div>
                <div className=" row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Paypal Tax</b>
                    </label>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      value={
                        getclientcountry === "91"
                          ? `₹${tax.toFixed(2)}`
                          : `${tax.toFixed(2)}`
                      }
                      type="text"
                      placeholder="Tax"
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-lg-5 col-md-6 mt-1">
                    <label className="form-label">
                      <b>Net Total</b>
                    </label>
                  </div>

                  <div className="col-lg-7 col-md-6">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Net Total"
                      value={
                        getclientcountry === "91"
                          ? `₹${Math.round(storedNetTotal).toFixed(2)}`
                          : `${Math.round(storedNetTotal).toFixed(2)}`
                      }
                      readOnly
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-5"></div>
            <div className="col-lg-7">
              <div
                style={{ marginLeft: "75px" }}
                className="d-flex justify-content-evenly mt-3 buttonstyle "
              >
                <button
                  type="button"
                  className="btn btn-danger invoice-button"
                  onClick={handleClearAll}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-info text-white invoice-button"
                  style={{ backgroundColor: "#007BFF" }}
                  onClick={handleback}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="btn btn-success invoice-button"
                  onClick={submitdata}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-secondary invoice-button"
                  onClick={handlenavigate}
                >
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Invoiceadd;